import { Field, IFieldProps, TFieldTheme } from '../utility/field/Field'
import React, { ForwardedRef, forwardRef, TextareaHTMLAttributes, useEffect, useState } from 'react'

export interface IBpTextAreaProps
  extends Omit<IFieldProps, 'children'>,
    TextareaHTMLAttributes<HTMLTextAreaElement> {
  disabled?: boolean
  error?: string | boolean
  success?: string
  height?: 'sm' | 'md' | 'lg'
}

export const BpTextArea = forwardRef(
  (props: IBpTextAreaProps, ref: ForwardedRef<HTMLTextAreaElement>) => {
    const {
      label,
      fieldSize,
      error,
      info,
      success,
      height = 'md',
      action,
      rightSection,
      ...areaProps
    } = props
    const { disabled, required } = areaProps

    const [theme, setTheme] = useState<TFieldTheme>('default')
    const [message, setMessage] = useState<string>()
    const [isFocus, setIsFocus] = useState<boolean>(false)

    useEffect(() => {
      if (disabled) {
        setTheme('disabled')
      } else if (error) {
        setTheme('error')
        if (typeof error === 'string') setMessage(error)
      } else if (success) {
        setTheme('success')
        setMessage(success)
      } else {
        setMessage('')
        isFocus ? setTheme('focus') : setTheme('default')
      }
    })

    return (
      <Field
        action={action}
        fieldSize={fieldSize}
        info={info}
        label={label}
        message={message}
        required={required}
        theme={theme}
      >
        <div className={'relative'}>
          <textarea
            {...areaProps}
            ref={ref}
            className={`flex h-[113px] ${{ sm: 'h-[72px]', md: 'h-full', lg: 'h-[114px]' }[height]} scrollbar-hide w-full rounded-[8px] border-none p-[12px] text-[15px] text-focus-500 outline-none placeholder:text-aqua-300 disabled:bg-transparent`}
            onBlur={(e) => {
              setIsFocus(false)
              areaProps.onBlur && areaProps.onBlur(e)
            }}
            onFocus={() => setIsFocus(true)}
          />
          {!isFocus && <div className={'absolute bottom-[8px] right-[8px]'}>{rightSection}</div>}
        </div>
      </Field>
    )
  },
)
